import { render, staticRenderFns } from "./StoreGeneralSettings.vue?vue&type=template&id=a0f9f6b4&scoped=true&"
import script from "./StoreGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./StoreGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./StoreGeneralSettings.vue?vue&type=style&index=0&id=a0f9f6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f9f6b4",
  null
  
)

export default component.exports